import { Link } from "react-router-dom";

export const MEDIA_CARD_GUTTER = "px-5 md:px-32 lg:px-40";
export const MEDIA_CARD_CLASS = "aspect-[4/5] md:aspect-square";
export const MEDIA_CARD_GRID = "grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-4";
export const MEDIA_CARD_GRID_3 = "grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-4";

export function categoryHref(item) {
  return item?.slug ? `/category/${item.slug}` : "/category";
}

export function productHref(item, categorySlug) {
  const cat = String(categorySlug || item?.category?.slug || "").trim();
  const slug = String(item?.slug || "").trim();
  if (cat && slug) return `/category/${cat}/${slug}`;
  return "/products";
}

function CategoryCard({
  to,
  photo,
  alt = "",
  title,
  description,
  overlay = null,
  lazy = false,
  revealIndex,
  className = "",
}) {
  return (
    <Link
      to={to}
      className={`media-card group relative flex flex-col justify-end overflow-hidden bg-at-dark p-4 text-white ${className || "aspect-square"}`.trim()}
      data-reveal={revealIndex == null ? undefined : ""}
      style={revealIndex == null ? undefined : { "--reveal-i": Math.min(revealIndex, 5) }}
    >
      {photo ? (
        <img
          src={photo}
          alt={alt}
          width={800}
          height={800}
          loading={lazy ? "lazy" : "eager"}
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : null}
      <span className="absolute inset-0 bg-black/50" />
      {overlay}
      <span className="relative z-[2] flex items-end justify-between gap-2">
        <span className="min-w-0">
          <h3 className="block text-sm font-semibold leading-tight sm:text-base">{title}</h3>
          <span className="mt-0.5 min-h-[2.75em] line-clamp-2 text-[10px] leading-snug text-at-gold sm:text-xs">
            {description || "\u00a0"}
          </span>
        </span>
        <span className="card-arrow shrink-0 text-lg text-at-gold">→</span>
      </span>
    </Link>
  );
}

export default CategoryCard;
